export const scrollLock = (openModal) => {
  const scrollPos = document.body;
  if (openModal === true) {
    scrollPos.style.overflowY = "hidden";
  } else {
    scrollPos.style.overflowY = "initial";
  }
};
